// extracted by mini-css-extract-plugin
module.exports = {"SVGIcon":"SVGIcon___2MRsa","SVGIconInner":"SVGIconInner___2OaCZ","ColorPrimary":"ColorPrimary___12lpd","loading":"loading___37loM"};